import styles from "./fit_layout.module.css";
import React, { useEffect } from "react";

export interface FitLayoutProps {
  title?: string;
  loading?: boolean;
  children: any;
  className?: string;
}

export const FitLayout = (props: FitLayoutProps) => {
  const {
    loading,
    children,
    title,
    className
  } = props;

  useEffect(() => {
    document.getElementsByTagName('main')[0]?.scrollTo(0,0);
  }, []);

  return (
    <div className={styles.fit_layout + (className ? ` ${className}` : '')}>
      <div className={styles.fit_layout__content}>
        {title && <h1 className={styles.fit_layout_title}>{title}</h1>}
        {children}
      </div>
      {loading && 
        <div className={styles.fit_layout_loading}>
          CARGANDO
        </div>
      }
    </div>
  );
};
